// extracted by mini-css-extract-plugin
export default {"wrapper":"scrollableContainerMobile-module__wrapper__1TfFu"};